import { WithSnowplow } from '@montugroup/data-collection';
import type { FC, PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';

export const SnowplowProvider: FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation();

  // TODO: If the backend were to provide us a way to access the logged in user data, we could track the user id here
  const childrenWithSnowplow = WithSnowplow(
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>,
    {
      appId: 'montu.supplier-portal',
      trackerName: 'hoc.montu-web/apps/supplier-portal',
      locationOverride: location,
      snowplowEndpointOverride: import.meta.env?.VITE_PUBLIC_SNOWPLOW_URL
    },
    true
  );

  return childrenWithSnowplow;
};
